<template>
  <section class="all-cases-view" v-loading="loading">
    <div class="primary-content-view-new" v-if="hospitalPhysicians">
      <div class="listings listings__table listings__all-cases">
        <el-table :data="hospitalPhysicians.data">
          <el-table-column
            label="NAME"
            prop="name"
            width="250"
          ></el-table-column>
          <el-table-column
            label="NPI CODE"
            prop="npi_code"
            width="150"
          ></el-table-column>
          <el-table-column
            label="EMAIL"
            prop="email"
            width="250"
          ></el-table-column>
          <el-table-column
            label="PHONE"
            prop="phone"
            width="180"
          ></el-table-column>
          <el-table-column label="FAX" prop="fax" width="150"></el-table-column>
          <el-table-column
            label="STATUS"
            prop="status"
            max-width="220"
            class="active-status"
          >
            <template #default="scope">
              <div class="column-status" v-if="scope.row.status">
                <span class="el-dropdown-link">
                  <el-tag :type="getStatusType(scope.row.status)"
                    >{{ scope.row.status }}
                  </el-tag>
                </span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="ACTIONS"
            prop="actions"
            fixed="right"
            width="100"
          >
            <template v-slot="scope">
              <ul class="listings__action-buttons">
                <li>
                  <el-button
                    :disabled="!scope.row._id"
                    title="Reset Password"
                    @click="onPasswordReset(scope.row)"
                    class="view-button"
                  >
                    <img
                      class="action-active"
                      src="@/assets/images/icons/actions/reset-active.svg"
                      alt="icon"
                    />
                    <img
                      class="action-inactive"
                      src="@/assets/images/icons/actions/reset-deactive.svg"
                      alt="icon"
                    />
                  </el-button>
                </li>
                <li v-if="hasPermission('physicians', 'add')">
                  <el-button
                    disabled
                    :title="`Edit ${scope.row.name}`"
                    @click="onEdit(scope.row)"
                    class="view-button"
                  >
                    <img
                      class="action-active"
                      src="@/assets/images/icons/actions/edit-active.svg"
                      alt="icon"
                    />
                    <img
                      class="action-inactive"
                      src="@/assets/images/icons/actions/edit-deactive.svg"
                      alt="icon"
                    />
                  </el-button>
                </li>
              </ul>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="listings listings__pagination">
        <el-pagination
          v-model:currentPage="page"
          v-model:page-size="pageSize"
          :page-sizes="[10, 25, 50, 100]"
          layout=" prev, pager, next, jumper, sizes ,total"
          :total="hospitalPhysicians.total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
    <div class="default-modal">
      <div v-if="SuccessPopup">
        <el-dialog top="10%" width="30%" v-model="SuccessPopup">
          <div class="popup-date pb-0">
            <div class="text-center">
              <img
                src="@/assets/images/icons/cases/success-popup-icon.svg"
                alt="icon"
              />
            </div>
            <div class="text-center mt-25">
              User Password reset Successfully! <br />
              User will recieve Email with new password !
            </div>
            <div class="dialog-footer justify-center">
              <el-button class="blue-save-button" @click="SuccessPopup = false">
                OK
              </el-button>
            </div>
          </div>
        </el-dialog>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
export default {
  mixins: [UserPermissionsHelper],

  data() {
    return {
      SuccessPopup: false,
      page: 1,
      pageSize: 10,
      loading: false,
      hospitalPhysicians: {
        data: [],
      },
    };
  },
  computed: {
    ...mapGetters("hospitals", [
      "getHospitalPhysicians",
      "getHospitalPhysicianDeleteStatus",
    ]),
    ...mapGetters("userAccounts", [
      "getUserAccountErrors",
      "getUserPasswordResetStatus",
    ]),
    ...mapGetters("errors", ["getErrors", "getError"]),
    hospital_id() {
      if (this.$route.params.hospital_id) {
        return this.$route.params.hospital_id;
      }
      return null;
    },
    getStatusType() {
      return (statusVal) => {
        const status = statusVal.trim();
        if (status == "ACTIVE") {
          return "default";
        } else if (status == "INACTIVE") {
          return "danger";
        } else {
          return "";
        }
      };
    },
  },
  async mounted() {
    await this.fetchPhysiciansList();
  },
  methods: {
    handleSizeChange(size) {
      this.pageSize = size;
      this.page = 1;

      this.fetchPhysiciansList();
    },
    handleCurrentChange(page) {
      this.page = page;

      this.fetchPhysiciansList();
    },
    async onEdit(data) {
      this.$router.push({
        name: "EditHospitalPhysician",
        params: {
          physician_id: data._id,
        },
        query: this.$route.query,
      });
    },
    async fetchPhysiciansList() {
      this.loading = true;
      let params = {
        hospital_id: this.hospital_id,
        page: this.page,
        limit: this.pageSize,
      };
      await this.$store.dispatch("hospitals/fetchHospitalPhysicians", params);
      this.loading = false;
      this.hospitalPhysicians = JSON.parse(
        JSON.stringify(this.getHospitalPhysicians)
      );
    },
    async onDelete(id) {
      this.$confirm("Are you sure to delete Physician?", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      }).then(() => {
        this.deletePhysician(id);
      });
    },
    async deletePhysician(id) {
      let params = {
        hospital_id: this.hospital_id,
        physician_id: id,
      };
      await this.$store.dispatch("hospitals/deleteHospitalPhysician", params);
      if (this.getHospitalPhysicianDeleteStatus) {
        successNotification("Physician deleted successfully");
        this.loading = true;
        await this.fetchPhysiciansList(1);
        this.loading = false;
      } else {
        errorNotification(this.getError || "Error while deleting Physician");
      }
    },
    onPasswordReset(user) {
      let userId = user._id;
      let userName = user.name;

      this.$confirm(
        `Are you sure want to  Reset <b>${
          userName || "User"
        }</b> 's Password. Continue ?`,
        "Warning",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      ).then(async () => {
        await this.resetPassword(userId);
      });
    },
    async resetPassword(id) {
      try {
        let params = {
          id,
        };
        await this.$store.dispatch(
          "userAccounts/resetUserAccountPassword",
          params
        );
        if (this.getUserPasswordResetStatus) {
          this.SuccessPopup = true;
        } else if (this.getUserAccountErrors) {
          this.$notify.error({
            title: "Error",
            message: this.getUserAccountErrors.critical_error,
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>
